import { BoostConfig } from 'src/Libs/flow/installation/forms'
import { WeekdayValue } from '../types'

type WeekdayValues = {
  monday: WeekdayValue
  tuesday: WeekdayValue
  wednesday: WeekdayValue
  thursday: WeekdayValue
  friday: WeekdayValue
  saturday: WeekdayValue
  sunday: WeekdayValue
}

/** Transforms the BoostConfig array into one week-worths of values*/
export const scheduleToWeekdayValues = (schedule: BoostConfig): WeekdayValues => {
  return {
    monday: getValueForDay(schedule, 'monday'),
    tuesday: getValueForDay(schedule, 'tuesday'),
    wednesday: getValueForDay(schedule, 'wednesday'),
    thursday: getValueForDay(schedule, 'thursday'),
    friday: getValueForDay(schedule, 'friday'),
    saturday: getValueForDay(schedule, 'saturday'),
    sunday: getValueForDay(schedule, 'sunday'),
  }
}

/** Searches for an entry for a day in the BoostConfig-Schedule and transforms it into a WeekdayValue */
export const getValueForDay = (schedule: BoostConfig, day: keyof BoostConfig[number]['weekDays']): WeekdayValue => {
  /*
   *  Get the first schedule entry where the weekday value is true.
   *  This works because only one schedule entry has a value of true for a specific day.
   */
  const value = schedule.find(entry => !!entry.weekDays[day])

  /** Return an 'empty' day  */
  if (!value) return { securityTemperature: undefined, fromTime: undefined, toTime: undefined }

  const numberedTemperature = Number(value.securityTemperature)
  return { securityTemperature: numberedTemperature, fromTime: value.fromTime, toTime: value.toTime }
}
